export default __webpack_public_path__ + "static/context-dont-2-dark-7c062abed29face965af799ac8bddd24.png";